module.exports = __webpack_public_path__ + "img/JJ.fc784e2f.png";